export default __webpack_public_path__ + "static/media/3233 knife block C side.043ea771.png";